import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CotizadoresService } from '../../../../services/cotizadores.service';
import { IFrameService } from '../../../../services/iframe/iframe.service';
import { SafeResourceUrl } from '@angular/platform-browser';
import { ClientInvoices } from '../../../../interfaces/payment.interfaces';
import { ClientInformation, IframeData, IframeTableColumnConfig, Invoice } from '../interfaces/payment-link-data.interfaces';
import { AuthService } from '../../../../services/auth.service';
import { GoogleAnalyticsService } from '../../../../services/google-analytics/google-analytics.service';

export interface Factura {
  poliza: string;
  factura: string;
  antiguedad: string;
  balance: number;
  currencyBalance: number;
  currencyDescription: string;
  minimoRD: number;
  pagarRD: number;
  acuerdo: string;
  montoAPagar: number;
  selected?: boolean;
}

@Component({
  selector: 'app-modal-facturas',
  standalone: true,
  imports: [CommonModule, FormsModule],
  template: `
    @if (isVisible) {
    <div class="modal-overlay">
      <div class="modal-content">
        <div class="modal-header">
          <div class="title-container">
            <h4 class="title-h4-blue">
              {{ clientName }}
            </h4>
            <h6>Facturas de Pago</h6>
          </div>
          <div class="search-container">
            <label for="filterText">Filtro de clientes</label>
            <input
              type="text"
              class="input-field"
              [(ngModel)]="filterText"
              (ngModelChange)="onFilterTextChange()"
            />
          </div>
        </div>

        <table class="facturas-table">
          <thead>
            <tr>
              <th>
                <input
                  type="checkbox"
                  [checked]="allSelected"
                  (change)="toggleSelectAll()"
                />
              </th>
              <th (click)="ordenar('poliza')">
                Póliza
                <i
                  class="bi"
                  [ngClass]="{
                    'bi-arrow-up': sortColumn === 'poliza' && !sortDesc,
                    'bi-arrow-down': sortColumn === 'poliza' && sortDesc
                  }"
                ></i>
              </th>
              <th (click)="ordenar('factura')">
                Factura
                <i
                  class="bi"
                  [ngClass]="{
                    'bi-arrow-up': sortColumn === 'factura' && !sortDesc,
                    'bi-arrow-down': sortColumn === 'factura' && sortDesc
                  }"
                ></i>
              </th>
              <th (click)="ordenar('antiguedad')">
                Ant.
                <i
                  class="bi"
                  [ngClass]="{
                    'bi-arrow-up': sortColumn === 'antiguedad' && !sortDesc,
                    'bi-arrow-down': sortColumn === 'antiguedad' && sortDesc
                  }"
                ></i>
              </th>
              <th (click)="ordenar('currencyDescription')">
                Moneda
                <i
                  class="bi"
                  [ngClass]="{
                    'bi-arrow-up':
                      sortColumn === 'currencyDescription' && !sortDesc,
                    'bi-arrow-down':
                      sortColumn === 'currencyDescription' && sortDesc
                  }"
                ></i>
              </th>

              <th (click)="ordenar('balance')">
                Balance
                <i
                  class="bi"
                  [ngClass]="{
                    'bi-arrow-up': sortColumn === 'balance' && !sortDesc,
                    'bi-arrow-down': sortColumn === 'balance' && sortDesc
                  }"
                ></i>
              </th>
              <th (click)="ordenar('minimoRD')">
                Mínimo DOP$
                <i
                  class="bi"
                  [ngClass]="{
                    'bi-arrow-up': sortColumn === 'minimoRD' && !sortDesc,
                    'bi-arrow-down': sortColumn === 'minimoRD' && sortDesc
                  }"
                ></i>
              </th>
              <th (click)="ordenar('pagarRD')">
                Pagar DOP
                <i
                  class="bi"
                  [ngClass]="{
                    'bi-arrow-up': sortColumn === 'pagarRD' && !sortDesc,
                    'bi-arrow-down': sortColumn === 'pagarRD' && sortDesc
                  }"
                ></i>
              </th>
              <th (click)="ordenar('acuerdo')">
                Acuerdo
                <i
                  class="bi"
                  [ngClass]="{
                    'bi-arrow-up': sortColumn === 'acuerdo' && !sortDesc,
                    'bi-arrow-down': sortColumn === 'acuerdo' && sortDesc
                  }"
                ></i>
              </th>
              <th (click)="ordenar('montoAPagar')">
                Monto a Pagar DOP
                <i
                  class="bi"
                  [ngClass]="{
                    'bi-arrow-up': sortColumn === 'montoAPagar' && !sortDesc,
                    'bi-arrow-down': sortColumn === 'montoAPagar' && sortDesc
                  }"
                ></i>
              </th>
            </tr>
          </thead>
          <tbody>
            @for (factura of paginatedData; track factura.poliza + '-' +
            factura.factura; let i = $index) {
            <tr [class]="getEstiloError(factura)">
              <td>
                <input
                  type="checkbox"
                  [checked]="factura.selected"
                  (change)="toggleSelect(factura)"
                />
              </td>
              <td>{{ factura.poliza }}</td>
              <td>{{ factura.factura }}</td>
              <td>{{ factura.antiguedad }}</td>
              <td>{{ factura.currencyDescription }}</td>
              <td>{{ factura.currencyBalance | currency : '$' }}</td>
              <td>{{ factura.minimoRD | currency : '$' }}</td>
              <td>{{ factura.pagarRD | currency : '$' }}</td>
              <td>{{ factura.acuerdo }}</td>
              <td>
                <input
                  type="number"
                  [(ngModel)]="factura.montoAPagar"
                  (ngModelChange)="onMontoChange(i, $event)"
                  [min]="factura.minimoRD"
                  [max]="factura.balance"
                  [disabled]="isFilaDeshabilitada(factura)"
                  [class.invalid-input]="
                    !isMontoValido(factura, factura.montoAPagar || 0)
                  "
                />
                @if (getEstiloError(factura)) {
                <div class="mensaje-error">
                  {{ getMensajeError(factura) }}
                </div>
                }
              </td>
            </tr>
            }
          </tbody>
        </table>

        <div class="pagination-container">
          <button
            class="page-link"
            [disabled]="currentPage === 1"
            (click)="onPageChange(currentPage - 1)"
          >
            anterior
          </button>

          <ul class="pagination">
            <li class="page-item" [class.active]="currentPage === 1">
              <a class="page-link" (click)="onPageChange(1)">1</a>
            </li>

            @if (currentPage > 3 && totalPages > 5) {
            <li class="page-item">
              <span class="page-link">...</span>
            </li>
            } @for (page of getVisiblePages(); track page) {
            <li class="page-item" [class.active]="currentPage === page">
              <a class="page-link" (click)="onPageChange(page)">{{ page }}</a>
            </li>
            } @if (currentPage < totalPages - 2 && totalPages > 5) {
            <li class="page-item">
              <span class="page-link">...</span>
            </li>
            } @if (totalPages > 1) {
            <li class="page-item" [class.active]="currentPage === totalPages">
              <a class="page-link" (click)="onPageChange(totalPages)">{{
                totalPages
              }}</a>
            </li>
            }
          </ul>

          <button
            class="page-link"
            [disabled]="currentPage === totalPages"
            (click)="onPageChange(currentPage + 1)"
          >
            siguiente
          </button>
        </div>

        <div class="modal-footer">
          <div class="total-container">
            <div class="total">
              Total a pagar: {{ totalAPagar | currency : 'DOP ' }}
            </div>
            <div class="tasa-cambio">
              Tasa de cambio: DOP {{ tasaCambio() }}
            </div>
          </div>
          <div class="actions">
            <button class="btn-cerrar" (click)="cerrarModal()">Cerrar</button>
            <button
              class="btn-agregar"
              [disabled]="!hayFacturasSeleccionadas()"
              (click)="agregarFacturas()"
            >
              Agregar Facturas
            </button>
            <button
              class="btn-link-pago"
              (click)="abrirIframeLinkPago()"
            >
              Link de pago
            </button>
          </div>
        </div>
      </div>
      @if(paymentLinkGenerator) {
      <div class="iframe-overlay">
        <iframe
          id="iframe-payment-link-generator"
          [src]="iframe"
          allowtransparency="true"
          style="border: none; background: transparent"
          width="100%"
          height="100%"
          allow="clipboard-write"
        >
        </iframe>
      </div>
      }
    </div>
    }
  `,
  styles: [
    `
      .modal-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        backdrop-filter: blur(10px);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1000;
      }

      .title-container {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
      }

      .search-container {
        display: flex;
        align-items: center;
        gap: 1rem;
        margin-bottom: 1rem;
      }

      .search-container label {
        color: #00558c;
        font-weight: 500;
        font-size: 14px;
      }

      .search-container .input-field {
        flex: 1;
        padding: 0.5rem;
        border: 1px solid #e8e8e8;
        border-radius: 4px;
        font-size: 14px;
      }

      .search-container .input-field:focus {
        outline: none;
        border-color: #0099dc;
      }

      .total-container {
        display: flex;
        flex-direction: column;
        gap: 1rem;
      }

      .modal-content {
        background: white;
        border-radius: 12px;
        padding: 2rem;
        width: 90%;
        max-width: 1200px;
        max-height: 90vh;
        overflow-y: auto;
      }

      .modal-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 2rem;
      }

      .modal-header h2 {
        color: #00558c;
        margin: 0;
        font-size: 1.5rem;
      }

      .facturas-table {
        width: 100%;
        border-collapse: collapse;
        margin-bottom: 2rem;
      }

      .facturas-table th,
      .facturas-table td {
        color: #00558c;
        padding: 0.35rem;
        text-align: left;
        border-bottom: 1px solid #e8e8e8;
        font-size: 12px;
      }

      .facturas-table th {
        background-color: #f8f9fa;
        color: #00558c;
        font-weight: 500;
      }

      .facturas-table input {
        width: 100%;
        padding: 0.5rem;
        border: 1px solid #e8e8e8;
        border-radius: 4px;
        font-size: 14px;
        cursor: pointer;
      }

      .invalid-input {
        border: 1px solid #ff9e1b;
        outline: none;
      }

      .modal-footer {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 2rem;
        padding-top: 1rem;
        border-top: 1px solid #e8e8e8;
      }

      .title-container h6 {
        color: #00558c;
        margin: 0;
      }

      .total {
        color: #00558c;
        font-weight: 600;
        font-size: 1.1rem;
      }

      .actions {
        display: flex;
        gap: 1rem;
      }

      .btn-cerrar,
      .btn-link-pago,
      .btn-agregar {
        padding: 0.5rem 2rem;
        border-radius: 4px;
        border: none;
        cursor: pointer;
        font-weight: 500;
        transition: all 0.3s ease;
      }

      .btn-cerrar {
        background-color: #f8f9fa;
        color: #6c757d;
      }

      .btn-cerrar:hover {
        background-color: #e2e6ea;
      }

      .btn-link-pago,
      .btn-agregar {
        background-color: #0099dc;
        color: white;
      }

      .btn-link-pago:hover,
      .btn-agregar:hover {
        background-color: #0088c5;
      }

      .btn-agregar:disabled {
        background-color: #e9ecef;
        color: #6c757d;
        cursor: not-allowed;
      }

      .tasa-cambio {
        color: #00aef0;
        font-weight: 600;
        font-size: 14px;
        border-radius: 4px;
        text-align: left;
      }

      .pagination-container {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        gap: 0.5rem;
      }

      .pagination {
        display: flex;
        list-style: none;
        margin: 0;
        padding: 0;
        gap: 0.25rem;
      }

      .page-item {
        margin: 0 1px;
      }

      .page-link {
        padding: 4px 8px;
        border: none;
        background: none;
        color: #00558c !important;
        cursor: pointer;
        border-radius: 4px;
        font-weight: 500;
        font-size: 12px;
        transition: all 0.3s ease;
      }

      .page-item.active .page-link {
        background-color: #00558c;
        color: white !important;
      }

      button.page-link {
        background-color: #f8f9fa;
        color: #00558c;
        font-size: 11px;
        padding: 4px 6px;
        border: none;
      }

      button.page-link:disabled {
        background-color: #e9ecef;
        color: #9ea6be !important;
        cursor: not-allowed;
      }

      .page-link:hover:not(:disabled) {
        background-color: #e9ecef;
      }

      .iframe-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        z-index: 9999;
      }

      /* Estilos responsivos */
      @media screen and (max-width: 1040px) {
        .modal-content {
          padding: 1rem;
          width: 95%;
        }

        .facturas-table {
          font-size: 12px;
        }

        .facturas-table th,
        .facturas-table td {
          padding: 0.5rem;
        }

        .btn-cerrar,
        .btn-agregar {
          padding: 0.5rem 1rem;
        }

        .pagination-container {
          padding: 0.5rem;
        }

        .pagination {
          font-size: 10px;
        }

        .page-link {
          padding: 3px 6px;
        }

        button.page-link {
          font-size: 10px;
        }
      }

      @media screen and (max-width: 768px) {
        .pagination-container {
          flex-direction: row;
          justify-content: center;
        }
      }

      .error-row {
        background-color: rgba(255, 0, 0, 0.05) !important;

        td {
          border-color: #ff4444;
        }

        input.invalid-input {
          border: 2px solid #ff9e1b;
        }
      }

      .invalid-input {
        border: 2px solid #ff9e1b;
      }

      .mensaje-error {
        color: #ff4444;
        font-size: 0.75rem;
        margin-top: 0.25rem;
      }
    `,
  ],
})
export class ModalFacturasComponent {
  @Input() isVisible: boolean = false;
  @Input() facturas: Factura[] = [];
  @Input() clientName: string = '';
  @Input() clientInfoAndInvoices: ClientInvoices | null = null;

  @Output() cerrar = new EventEmitter<void>();
  @Output() agregar = new EventEmitter<Factura[]>();

  constructor(
    private cotizadoresService: CotizadoresService,
    private iframesService: IFrameService,
    private authService: AuthService,
    private gAnalytics:GoogleAnalyticsService
  ) {
    this.iframe = this.iframesService.getIframeUrl();
  }

  /**
 * Inicializa el componente
 * Configura el formulario, la comunicación con el iframe y la suscripción al tema
 */
  ngOnInit() {
    this.setupIframeCommunication();
  }


  tasaCambio(): number {
    let tasaConversion = this.cotizadoresService.getTasaCambio();
    return tasaConversion;
  }

  totalAPagar: number = 0;
  facturasData: Factura[] = [];

  itemsPerPage: number = 6;
  currentPage: number = 1;
  totalPages: number = 0;
  paginatedData: Factura[] = [];

  sortColumn: string | null = null;
  sortDesc: boolean = false;
  allSelected: boolean = false;

  filterText: string = '';

  ngOnChanges(changes: SimpleChanges) {
    if (changes['facturas'] && changes['facturas'].currentValue) {
      this.facturasData = [...changes['facturas'].currentValue];
      this.updatePagination();
      this.calcularTotal();
    }
  }

  updatePagination() {
    this.totalPages = Math.ceil(this.facturasData.length / this.itemsPerPage);
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    this.paginatedData = this.facturasData.slice(startIndex, endIndex);
  }

  onPageChange(page: number) {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
      this.updatePagination();

      this.gAnalytics.trackEvent('click_paginacion',{
      page:'/pagos-online',
      action:'Paginacion en tabla de facturas'
    })
      
    }
  }

  getVisiblePages(): number[] {
    const delta = 2;
    const range: number[] = [];
    const seen = new Set<number>();

    for (
      let i = Math.max(2, this.currentPage - delta);
      i <= Math.min(this.totalPages - 1, this.currentPage + delta);
      i++
    ) {
      if (!seen.has(i)) {
        seen.add(i);
        range.push(i);
      }
    }

    return range;
  }

  ordenar(columna: keyof Factura) {
    if (this.sortColumn === columna) {
      this.sortDesc = !this.sortDesc;
    } else {
      this.sortColumn = columna;
      this.sortDesc = false;
    }

    this.facturasData.sort((a, b) => {
      let valorA = a[columna];
      let valorB = b[columna];

      if (valorA === null || valorA === undefined)
        return this.sortDesc ? -1 : 1;
      if (valorB === null || valorB === undefined)
        return this.sortDesc ? 1 : -1;

      if (typeof valorA === 'number' && typeof valorB === 'number') {
        return this.sortDesc ? valorB - valorA : valorA - valorB;
      }

      const strA = String(valorA).toLowerCase();
      const strB = String(valorB).toLowerCase();

      return this.sortDesc
        ? strB.localeCompare(strA)
        : strA.localeCompare(strB);
    });

    this.updatePagination();
  }

  toggleSelectAll() {

    this.gAnalytics.trackEvent('seleccionar_todas_las_facturas',{
      page:'/pagos-online',
      action:'Seleccionar todas las facturas a pagar en modal de facturas'
    })


    this.allSelected = !this.allSelected;
    this.facturasData.forEach((factura) => {
      factura.selected = this.allSelected;
      if (!this.allSelected) {
        factura.montoAPagar = 0;
      } else {
        factura.montoAPagar = factura.balance;
      }
    });
    this.calcularTotal();
    this.updatePagination();
  }

  toggleSelect(factura: Factura) {
  
     this.gAnalytics.trackEvent('seleccionar_factura',{
      page:'/pagos-online',
      action:'Seleccionar factura individual en el modal de facturas',
    })

    factura.selected = !factura.selected;
    if (!factura.selected) {
      factura.montoAPagar = 0;
    } else {
      factura.montoAPagar = factura.balance;
    }
    this.allSelected = this.facturasData.every((f) => f.selected);
    this.calcularTotal();
  }

  onMontoChange(index: number, monto: number) {
    if (
      this.facturasData[index] &&
      this.isMontoValido(this.facturasData[index], monto)
    ) {
      this.facturasData[index].montoAPagar = monto;
      this.calcularTotal();
    }
  }

  isMontoValido(factura: Factura, monto: number): boolean {
    return factura && monto >= factura.minimoRD && monto <= factura.balance;
  }

  calcularTotal() {
    this.totalAPagar = this.facturasData.reduce(
      (sum, factura) => sum + (factura.montoAPagar || 0),
      0
    );
  }

  hayFacturasSeleccionadas(): boolean {
    const todasLasFacturasValidas = this.facturasData
      .filter((f) => f.selected)
      .every((f) => this.isMontoValido(f, f.montoAPagar));

    const hayAlgunaSeleccionada = this.facturasData.some((f) => f.selected);

    return hayAlgunaSeleccionada && todasLasFacturasValidas;
  }

  isFilaDeshabilitada(factura: Factura): boolean {
    return !factura.selected;
  }

  cerrarModal() {
    this.cerrar.emit();
  }

  agregarFacturas() {
    const facturasSeleccionadas = this.facturasData.filter(
      (f) => f.montoAPagar > 0
    );

    this.gAnalytics.trackEvent('agregar_factura',{
      page:'/pagos-online',
      action:'Agregar factura'
    })

    this.agregar.emit(facturasSeleccionadas);
  }

  getEstiloError(factura: Factura): string {
    if (!factura.selected) return '';

    return !this.isMontoValido(factura, factura.montoAPagar) ? 'error-row' : '';
  }

  onFilterTextChange() {
    if (!this.filterText.trim()) {
      this.facturasData = [...this.facturas];
    } else {
      const searchText = this.filterText.toLowerCase();
      this.facturasData = this.facturas.filter(
        (factura) =>
          factura.poliza.toLowerCase().includes(searchText) ||
          factura.factura.toLowerCase().includes(searchText)
      );
    }
    this.currentPage = 1;
    this.updatePagination();
  }

  getMensajeError(factura: Factura): string {
    if (!factura.selected) return '';

    if (factura.montoAPagar < factura.minimoRD) {
      return `Monto mínimo: ${factura.minimoRD.toLocaleString('es-DO', {
        style: 'currency',
        currency: 'DOP',
      })}`;
    } else if (factura.montoAPagar > factura.balance) {
      return `Monto máximo: ${factura.balance.toLocaleString('es-DO', {
        style: 'currency',
        currency: 'DOP',
      })}`;
    }

    return '';
  }

  // iFrame
  public iframe: SafeResourceUrl;
  paymentLinkGenerator = false;

  /**
  * Configura la comunicación con el iframe
  * Establece el callback para cerrar el gestor de cotizaciones
  */
  private setupIframeCommunication() {
    this.iframesService.setupIframeCommunication(() => {
      this.cerrarIframeLinkPago();
    });
  }

  abrirIframeLinkPago() {
    this.gAnalytics.trackEvent('abrir_link_pago',{
      page:'/pagos-online',
      action:'Abrir link de pago'
    })

    this.paymentLinkGenerator = true;
    this.iframesService.preventBodyScroll();
    this.enviarDatosIframeLinkPago();
  }

  enviarDatosIframeLinkPago() {
    setTimeout(() => {
      this.iframesService.sendMessageToIframe('paymentData', this.mappedIframeData());
    }, 1500);
  }

  /**
   * Cierra el gestor de cotizaciones
   * Restaura el scroll del body
   */
  cerrarIframeLinkPago() {
    this.paymentLinkGenerator = false;
    this.iframesService.restoreBodyScroll();
  }

  mappedIframeData(): IframeData {
    const tableColumnsConfig: IframeTableColumnConfig[] = [
      { key: 'policyNumber', label: 'Póliza', type: 'text' },
      { key: 'documentNumber', label: 'Factura', type: 'text' },
      { key: 'currencyDescription', label: 'Moneda', type: 'text' },
      { key: 'currencyBalance', label: 'Balance en moneda', type: 'number', format: 'currency' },
      { key: 'balance', label: 'Balance en DOP', type: 'number', format: 'currency' },
      { key: 'minAmount', label: 'Pago mínimo en DOP', type: 'number', format: 'currency' },
    ]

    const clientInformation: ClientInformation = {
      clientCode: this.clientInfoAndInvoices?.clientCode || 0,
      producerNumber: this.authService.getProducerNumber() || 0,
      producerName: this.authService.getProducerName() || '',
      idType: this.clientInfoAndInvoices?.idType || 0,
      idNumber: this.clientInfoAndInvoices?.idNumber || '',
      clientName: this.clientInfoAndInvoices?.clientName || '',
      conversionRate: this.tasaCambio() || 0,
      paymentType: 1, // 1: Facturas, 2: Acuerdos
      paymentTypeDescription: 'Facturas',
    }

    const invoices: Invoice[] = this.clientInfoAndInvoices?.invoices.map(invoice => ({
      policyNumber: invoice.policyNumber,
      documentType: invoice.documentType,
      documentNumber: invoice.documentNumber,
      cCurrency: invoice.cCurrency,
      minAmount: invoice.minAmount,
      currencyDescription: invoice.currencyDescription,
      currencyBalance: invoice.currencyBalance,
      balance: invoice.balance,
    })) || [];

    return { invoices, clientInformation, tableColumnsConfig }
  }



}
